/*
 * Converts between shipstation-ui's dimension unit of measure and ui-component's dimension unit of measure.
 */

import { DimensionInputUnit } from 'ui-components/components/dimension-input/units';

import { DimensionUnit } from '../../../enums/dimension-unit';

export const convertToDimensionUnitEnum = (dimensionInputUnit) => {
  if ([DimensionInputUnit.centimeters, DimensionInputUnit.centimeter].includes(`${dimensionInputUnit}`.toLowerCase())) {
    return DimensionUnit.Centimeters;
  }

  return DimensionUnit.Inches;
};

export const convertFromDimensionUnitEnum = (dimensionUnitEnum) => {
  if ([DimensionUnit.Centimeters, DimensionUnit.Centimeter].includes(dimensionUnitEnum)) {
    return DimensionInputUnit.centimeters;
  }

  return DimensionInputUnit.inches;
};
